import axios from "axios";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
const includes = [
    "field_project_image.field_media_image",
    "field_project_image.field_media_svg_image",
    "field_project_category_list_icon.field_media_image",
    "field_project_category_list_icon.field_media_svg_image",
];
export const getSolarCal = async () => {
    const response = await fetch(
        `${API_BASE_CMS}/jsonapi/node/solar_calculation`
    );

    if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
    }

    const { data } = await response.json();
   
    return data;
};
export const getSolarCalfield = async (uid: string) => {
  const res = await axios.get(
    `${API_BASE_CMS}/jsonapi/node/solar_calculation_field/${uid}`,
    {
      params: {
         include: "field_solar_field",
      },
    }
  );

  const { data, included = [] } = res.data;

 
    const formfield =
    data?.relationships?.field_solar_field?.data.map(
      (ref: any) => {
        const para = included.find(
          (i: any) =>
            i.type === "paragraph--solar_calculator_field" &&
            i.id === ref.id
        );
 
        return {
            name: para?.attributes?.field_name || "",
            value: para?.attributes?.field_value || ""
        };
      }
    ) || [];

  return {
    data,formfield
  };
};


